/**
 * Phase 21 — the order the drops read in: drops on the clock in their own
 * order (the order you drag), a pinned drop slotted in by its minute. Pure,
 * so the list and its spec agree.
 * For Media Devoted | Created By Ciro Autiero
 */
import type { DraftSlot } from '../../../../../drop-generator.types';
import { slotKey, type SlotTime } from '../../../../../utils/slot-times';

export interface DropRowModel {
  slot: DraftSlot;
  /** Position in draft.slots — what every edit dispatches with. */
  index: number;
  key: string;
  time: SlotTime | undefined;
  pinned: boolean;
}

/** 19/10/2026 — one compact line per drop, no sideways sliding: time + country time, group + list, gateway + sender.
 *  The time column fits "20:00 −1d 📌 🇦🇺 05:00 +1d 🌙✓" (20/10/2026 — the moon chip spilled under the group chips). */
export const DROP_GRID =
  'grid grid-cols-[14px_18px_192px_minmax(0,1.6fr)_minmax(0,1fr)_60px_36px_18px] items-center gap-x-2';

export function dropRows(slots: DraftSlot[], timesByKey: Map<string, SlotTime>): DropRowModel[] {
  const rows = slots.map((slot, index) => ({
    slot,
    index,
    key: slotKey(slot, index),
    time: timesByKey.get(slotKey(slot, index)),
    pinned: slot.pinnedAtMin !== null,
  }));
  const out = rows.filter((r) => !r.pinned);
  for (const pin of rows.filter((r) => r.pinned)) {
    const at = out.findIndex(
      (r) => r.slot.enabled && r.time !== undefined && r.time.minute > (pin.time?.minute ?? (pin.slot.pinnedAtMin as number)),
    );
    out.splice(at < 0 ? out.length : at, 0, pin);
  }
  return out;
}
